(function () {
  var refreshInFlight = null;
  var lastEventAt = 0;
  var lastCart = null;
  var loadingMarkup = '<div class="loading-overlay loading-overlay--custom"><div class="loading-overlay__spinner"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div></div>';
  var vitalPropertyKeys = {
    garment: true,
    colour: true,
    color: true,
    size: true
  };
  var hiddenPropertyKeys = {
    "thumb url": true,
    "pf preview image": true,
    "preview image": true,
    "pf preview image s3": true
  };

  function route(path) {
    var root = window.routes && typeof window.routes.root === "string" ? window.routes.root : "";
    return root.replace(/\/$/, "") + path;
  }

  function normalizeCart(detail) {
    if (!detail) return null;
    return detail.cart || detail;
  }

  function propertyValue(properties, name) {
    if (!properties) return null;
    if (Array.isArray(properties)) {
      var match = properties.find(function (property) {
        return property && (property.name === name || property.key === name || property[0] === name);
      });
      return match ? match.value || match[1] : null;
    }
    return properties[name];
  }

  function propertyEntries(properties) {
    if (!properties) return [];
    if (Array.isArray(properties)) {
      return properties.map(function (property) {
        if (!property) return null;
        return {
          name: property.name || property.key || property[0],
          value: property.value || property[1]
        };
      }).filter(Boolean);
    }
    return Object.keys(properties).map(function (name) {
      return { name: name, value: properties[name] };
    });
  }

  function cleanPropertyName(name) {
    return String(name || "").replace(/:$/, "").trim().toLowerCase();
  }

  function cleanPropertyKey(name) {
    return cleanPropertyName(name).replace(/_/g, " ").replace(/-/g, " ").replace(/\s+/g, " ");
  }

  function isBuilderItem(item) {
    var properties = item && item.properties ? item.properties : {};
    return Boolean(
      propertyValue(properties, "_pf_builder_version") ||
      propertyValue(properties, "_pf_builder_payload") ||
      propertyValue(properties, "_pf_preview_image")
    );
  }

  function hasBuilderLine(cart) {
    return Boolean(cart && Array.isArray(cart.items) && cart.items.some(isBuilderItem));
  }

  function sideCartWrapper() {
    return document.querySelector("#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper") ||
      document.querySelector("#halo-cart-sidebar .previewCart-wrapper");
  }

  function fetchCartJson() {
    return fetch(route("/cart.js"), {
      headers: { "Accept": "application/json" },
      credentials: "same-origin",
      cache: "no-store"
    }).then(function (response) {
      if (!response.ok) throw new Error("Could not load cart.");
      return response.json();
    }).then(function (cart) {
      lastCart = cart;
      return cart;
    });
  }

  function fetchSideCartHtml() {
    return fetch(route("/cart?view=ajax_side_cart"), {
      headers: { "Accept": "text/html" },
      credentials: "same-origin",
      cache: "no-store"
    }).then(function (response) {
      if (!response.ok) throw new Error("Could not load cart drawer.");
      return response.text();
    });
  }

  function showLoading() {
    var wrapper = sideCartWrapper();
    document.body.classList.add("cart-sidebar-show");

    if (!wrapper) return;
    if (!wrapper.querySelector(".loading-overlay")) {
      wrapper.insertAdjacentHTML("afterbegin", loadingMarkup);
    }
    wrapper.classList.add("is-loading");
  }

  function rerunInsertedScripts(wrapper) {
    Array.from(wrapper.getElementsByTagName("script")).forEach(function (oldScript) {
      var newScript = document.createElement("script");
      Array.from(oldScript.attributes).forEach(function (attr) {
        newScript.setAttribute(attr.name, attr.value);
      });
      newScript.appendChild(document.createTextNode(oldScript.innerHTML));
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  function updateCartCount(cart) {
    if (!cart || typeof cart.item_count === "undefined") return;
    document.querySelectorAll("[data-cart-count]").forEach(function (element) {
      element.textContent = cart.item_count;
    });
    document.querySelectorAll("[data-cart-text]").forEach(function (element) {
      element.textContent = cart.item_count === 1 ? "item" : "items";
    });
  }

  function lineSelector(key) {
    if (window.CSS && typeof window.CSS.escape === "function") {
      return '[data-line="' + window.CSS.escape(key) + '"]';
    }
    return '[data-line="' + String(key).replace(/"/g, '\\"') + '"]';
  }

  function builderEditUrlForItem(item) {
    if (!isBuilderItem(item) || !item.key) return "";
    return route("/pages/build-your-armour?cartLineKey=" + encodeURIComponent(item.key));
  }

  function ensureBuilderEditLink(row, item) {
    var editUrl = builderEditUrlForItem(item);
    if (!editUrl) return;

    var existing = row.querySelector("[data-pf-builder-edit-link]");
    if (existing) {
      existing.href = editUrl;
      return;
    }

    var link = document.createElement("a");
    link.className = "pf-builder-cart-edit";
    link.href = editUrl;
    link.setAttribute("data-pf-builder-edit-link", "");
    link.textContent = "Edit Design";

    var properties = row.querySelector(".cart-item-properties, .card-properties");
    if (properties && properties.parentNode) {
      properties.insertAdjacentElement("afterend", link);
      return;
    }

    var name = row.querySelector(".previewCartItem-name, .cart-item-name");
    if (name && name.parentNode) {
      name.insertAdjacentElement("afterend", link);
    }
  }

  function builderPayloadForItem(item) {
    var raw = propertyValue(item && item.properties, "_pf_builder_payload");
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (error) {
      return null;
    }
  }

  function printViewsForItem(item) {
    var payload = builderPayloadForItem(item);
    var views = {};
    var selections = payload && Array.isArray(payload.selections) ? payload.selections : [];

    selections.forEach(function (selection) {
      var text = [
        selection.locationKey,
        selection.locationName,
        selection.placement,
        selection.platen,
        selection.platenName
      ].join(" ").toLowerCase();

      if (text.indexOf("back") !== -1) {
        views.back = true;
      } else if (text.indexOf("left") !== -1) {
        views.left = true;
      } else if (text.indexOf("right") !== -1) {
        views.right = true;
      } else {
        views.front = true;
      }
    });

    return views;
  }

  function addPreviewImage(images, seen, image) {
    var url = String(image && image.url ? image.url : "").trim();
    if (!url || seen[url]) return;
    seen[url] = true;
    images.push({
      key: image.key || "preview",
      label: image.label || "Preview",
      url: url
    });
  }

  function previewImagesForItem(item) {
    var properties = item && item.properties ? item.properties : {};
    var primaryCandidates = [
      { key: "front", label: "Front", url: propertyValue(properties, "_pf_preview_image_front") },
      { key: "back", label: "Back", url: propertyValue(properties, "_pf_preview_image_back") }
    ];
    var extraCandidates = [
      { key: "left", label: "Left", url: propertyValue(properties, "_pf_preview_image_left") },
      { key: "right", label: "Right", url: propertyValue(properties, "_pf_preview_image_right") }
    ];
    var fallback = propertyValue(properties, "_pf_preview_image") ||
      propertyValue(properties, "PF Preview Image") ||
      propertyValue(properties, "Preview Image");
    var images = [];
    var seen = {};

    primaryCandidates.forEach(function (image) {
      addPreviewImage(images, seen, image);
    });

    if (images.length < 2) {
      var printedViews = printViewsForItem(item);
      var hasPrintedView = Object.keys(printedViews).length > 0;
      extraCandidates.forEach(function (image) {
        if (!hasPrintedView || printedViews[image.key]) {
          addPreviewImage(images, seen, image);
        }
      });
    }

    if (images.length < 2) {
      addPreviewImage(images, seen, { key: "preview", label: "Preview", url: fallback });
    }

    return images;
  }

  function previewImageForItem(item) {
    var images = previewImagesForItem(item);
    return images.length ? images[0].url : "";
  }

  function vitalPropertiesForItem(item) {
    var details = [];
    propertyEntries(item && item.properties).forEach(function (property) {
      var key = cleanPropertyKey(property.name);
      if (!property.value || !vitalPropertyKeys[key]) return;
      details.push({
        name: key === "color" ? "Colour" : String(property.name || "").replace(/:$/, ""),
        value: property.value
      });
    });
    var printCount = propertyValue(item && item.properties, "_pf_print_count");
    if (printCount) {
      details.push({
        name: "Prints",
        value: printCount
      });
    }
    return details;
  }

  function cleanupBuilderProperties(row, item) {
    var builder = isBuilderItem(item);
    row.querySelectorAll("[data-pf-builder-thumb-url], .pf-builder-thumb-url").forEach(function (element) {
      element.remove();
    });

    row.querySelectorAll(".cart-item-properties .product-option, .card-properties .product-option").forEach(function (option) {
      var keyNode = option.querySelector(".definitionList-key");
      var key = cleanPropertyKey(keyNode ? keyNode.textContent : "");
      var hidden = key.charAt(0) === "_" || hiddenPropertyKeys[key] || key.indexOf("pf ") === 0;

      if (builder && !vitalPropertyKeys[key]) hidden = true;
      if (hidden) option.remove();
    });
  }

  function applyCartPreviewImages(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    lastCart = cart;

    cart.items.forEach(function (item) {
      if (!isBuilderItem(item) || !item.key) return;

      var previewImage = previewImageForItem(item);
      document.querySelectorAll(lineSelector(item.key)).forEach(function (row) {
        cleanupBuilderProperties(row, item);
        ensureBuilderEditLink(row, item);
        if (!previewImage) return;

        var imageLink = row.querySelector(".previewCartItem-image, .cart-item-image");
        if (!imageLink) return;

        imageLink.classList.add("pf-builder-cart-thumb");
        imageLink.setAttribute("data-pf-builder-preview-trigger", "");
        imageLink.setAttribute("data-pf-builder-line", item.key);
        imageLink.setAttribute("aria-label", "View Build Your Armour previews");

        var image = imageLink.querySelector("img");
        if (!image) {
          image = document.createElement("img");
          image.alt = item.product_title || item.title || "Custom shirt preview";
          image.loading = "lazy";
          imageLink.appendChild(image);
        }

        image.src = previewImage;
        image.removeAttribute("srcset");
        image.classList.add("pf-builder-cart-preview");
      });
    });
  }

  function modalMarkup() {
    return [
      '<div class="pf-builder-cart-modal__backdrop" data-pf-builder-modal-close></div>',
      '<div class="pf-builder-cart-modal__panel" role="document">',
      '<button type="button" class="pf-builder-cart-modal__close" data-pf-builder-modal-close aria-label="Close preview">&times;</button>',
      '<div class="pf-builder-cart-modal__header">',
      '<h2 class="pf-builder-cart-modal__title"></h2>',
      '<div class="pf-builder-cart-modal__meta"></div>',
      '</div>',
      '<div class="pf-builder-cart-modal__gallery"></div>',
      '</div>'
    ].join("");
  }

  function ensureModal() {
    var modal = document.getElementById("pf-builder-cart-modal");
    if (modal) return modal;

    modal = document.createElement("div");
    modal.id = "pf-builder-cart-modal";
    modal.className = "pf-builder-cart-modal";
    modal.setAttribute("role", "dialog");
    modal.setAttribute("aria-modal", "true");
    modal.setAttribute("aria-hidden", "true");
    modal.innerHTML = modalMarkup();
    document.body.appendChild(modal);
    return modal;
  }

  function closeModal() {
    var modal = document.getElementById("pf-builder-cart-modal");
    if (!modal) return;
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("pf-builder-cart-modal-open");
  }

  function openBuilderModal(item) {
    var images = previewImagesForItem(item);
    if (!images.length) return;

    var modal = ensureModal();
    var title = modal.querySelector(".pf-builder-cart-modal__title");
    var meta = modal.querySelector(".pf-builder-cart-modal__meta");
    var gallery = modal.querySelector(".pf-builder-cart-modal__gallery");
    var closeButton = modal.querySelector(".pf-builder-cart-modal__close");
    var details = vitalPropertiesForItem(item);

    title.textContent = item.product_title || "Build Your Armour";
    meta.innerHTML = "";
    details.forEach(function (detail) {
      var chip = document.createElement("span");
      chip.className = "pf-builder-cart-modal__chip";
      chip.textContent = detail.name + ": " + detail.value;
      meta.appendChild(chip);
    });

    gallery.innerHTML = "";
    gallery.className = "pf-builder-cart-modal__gallery";
    if (images.length === 1) {
      gallery.classList.add("pf-builder-cart-modal__gallery--single");
    }

    images.forEach(function (image) {
      var figure = document.createElement("figure");
      var img = document.createElement("img");
      var caption = document.createElement("figcaption");

      figure.className = "pf-builder-cart-modal__figure";
      img.src = image.url;
      img.alt = image.label + " custom print preview";
      img.loading = "lazy";
      caption.textContent = image.label;
      figure.appendChild(img);
      figure.appendChild(caption);
      gallery.appendChild(figure);
    });

    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("pf-builder-cart-modal-open");
    if (closeButton) closeButton.focus();
  }

  function findCartItemByKey(key) {
    if (!key || !lastCart || !Array.isArray(lastCart.items)) return null;
    return lastCart.items.find(function (item) {
      return item && item.key === key;
    }) || null;
  }

  function cartLineKeyFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search || "");
      return params.get("cartLineKey") ||
        params.get("cart_line_key") ||
        params.get("lineKey") ||
        params.get("cartItemKey") ||
        "";
    } catch (error) {
      return "";
    }
  }

  function cartItemMatchesRequestedKey(item, key) {
    if (!item || !item.key || !key) return false;
    if (item.key === key) return true;
    try {
      return item.key === decodeURIComponent(key);
    } catch (error) {
      return false;
    }
  }

  function findCartItemByRequestedKey(cart, key) {
    if (!cart || !Array.isArray(cart.items) || !key) return null;
    return cart.items.find(function (item) {
      return cartItemMatchesRequestedKey(item, key);
    }) || null;
  }

  function postCartLineToBuilder(frame, item) {
    var payload = propertyValue(item && item.properties, "_pf_builder_payload");
    if (!frame || !frame.contentWindow || !payload) return;
    frame.contentWindow.postMessage({
      type: "pf:armor-builder:load-cart-line",
      lineKey: item.key,
      payload: payload
    }, "*");
  }

  function initEditorCartLineBridge() {
    var frame = document.getElementById("pf-gymtier-builder-frame");
    var requestedKey = cartLineKeyFromUrl();
    if (!frame || !requestedKey) return;

    fetchCartJson()
      .then(function (cart) {
        var item = findCartItemByRequestedKey(cart, requestedKey);
        if (!isBuilderItem(item)) return;

        var postAttempts = 0;
        var post = function () {
          postAttempts += 1;
          postCartLineToBuilder(frame, item);
          if (postAttempts < 5) {
            window.setTimeout(post, postAttempts * 450);
          }
        };

        frame.addEventListener("load", post, { once: true });
        post();
      })
      .catch(function () {});
  }

  function openBuilderModalByKey(key) {
    var item = findCartItemByKey(key);
    if (item) {
      openBuilderModal(item);
      return;
    }

    fetchCartJson()
      .then(function () {
        var freshItem = findCartItemByKey(key);
        if (freshItem) openBuilderModal(freshItem);
      })
      .catch(function () {});
  }

  function syncHaloExtras(wrapper, cart) {
    if (window.halo && typeof window.halo.dispatchChangeForShippingMessage === "function") {
      window.halo.dispatchChangeForShippingMessage();
    }
    if (window.halo && typeof window.halo.productCollectionCartSlider === "function") {
      window.halo.productCollectionCartSlider();
    }
    if (window.halo && typeof window.halo.updateGiftWrapper === "function") {
      window.halo.updateGiftWrapper();
    }
    if (window.halo && typeof window.halo.getProductCardOfferCounts === "function" && window.jQuery) {
      var response = window.jQuery(wrapper);
      var offerCounts = window.halo.getProductCardOfferCounts(response);
      if (typeof window.halo.publishMixMatchOfferCounts === "function") {
        window.halo.publishMixMatchOfferCounts(offerCounts, "pf-armor-builder-cart");
      }
      if (typeof window.halo.updateProductCardOfferBadges === "function") {
        window.halo.updateProductCardOfferBadges(offerCounts);
      }
      if (typeof window.halo.updateProductCardOfferPricing === "function") {
        window.halo.updateProductCardOfferPricing(offerCounts, cart && cart.currency ? cart.currency : "GBP");
      }
    }
  }

  function refreshSideCart(cart) {
    showLoading();

    return fetchSideCartHtml()
      .then(function (html) {
        var wrapper = sideCartWrapper();
        if (!wrapper) return cart;
        wrapper.innerHTML = html;
        rerunInsertedScripts(wrapper);
        updateCartCount(cart);
        applyCartPreviewImages(cart);
        syncHaloExtras(wrapper, cart);
        document.dispatchEvent(new CustomEvent("cart-update", { detail: { cart: cart } }));
        return cart;
      })
      .finally(function () {
        var wrapper = sideCartWrapper();
        if (wrapper) wrapper.classList.remove("is-loading");
      });
  }

  function openHaloSideCart(cart) {
    var cartPromise = fetchCartJson().catch(function () {
      return cart && Array.isArray(cart.items) ? cart : null;
    });

    refreshInFlight = cartPromise
      .then(function (freshCart) {
        if (!hasBuilderLine(freshCart)) return null;
        return refreshSideCart(freshCart);
      })
      .catch(function () {
        updateCartCount(cart);
      })
      .finally(function () {
        refreshInFlight = null;
      });

    return refreshInFlight;
  }

  function handleCartEvent(event) {
    var now = Date.now();
    if (now - lastEventAt < 100) return;
    lastEventAt = now;

    var cart = normalizeCart(event && event.detail);
    if (cart) lastCart = cart;
    if (refreshInFlight) return;
    openHaloSideCart(cart);
  }

  document.addEventListener("click", function (event) {
    var trigger = event.target.closest("[data-pf-builder-preview-trigger]");
    if (!trigger) return;

    var row = trigger.closest("[data-line]");
    var key = trigger.getAttribute("data-pf-builder-line") || (row ? row.getAttribute("data-line") : "");
    if (!key) return;

    event.preventDefault();
    openBuilderModalByKey(key);
  });

  document.addEventListener("click", function (event) {
    if (event.target.closest("[data-pf-builder-modal-close]")) {
      event.preventDefault();
      closeModal();
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeModal();
  });

  document.addEventListener("cart:updated", handleCartEvent);
  document.addEventListener("pf:armor-builder:cart-added", handleCartEvent);
  window.addEventListener("cart:updated", handleCartEvent);
  window.addEventListener("pf:armor-builder:cart-added", handleCartEvent);

  document.addEventListener("DOMContentLoaded", function () {
    initEditorCartLineBridge();

    fetchCartJson()
      .then(function (cart) {
        if (hasBuilderLine(cart)) applyCartPreviewImages(cart);
      })
      .catch(function () {});
  });
})();
